import { ContextOrderBasketType } from "../../../../hooks/useBasketContext.shared";

import { ProductTypesFlat } from "@sellar-io/common";

export const productTypes = () => {
  return ["cask", "keg"]
    .map((type: string) => {
      return ProductTypesFlat.filter((flatType) =>
        flatType.path?.includes(type.toLowerCase()),
      ).map((filtered) => filtered.key);
    })
    .flat();
};

export const getParentIdsForBadgesFromOrder = (
  order: ContextOrderBasketType | null,
) => {
  return order?.OrderItems?.map((item) => {
    return item.Product.type === "productItem" &&
      productTypes().includes(item.Product.containerType ?? "")
      ? item.Product.ParentId
      : false;
  })
    .filter(Boolean)
    .filter((value, index, self) => self.indexOf(value) === index);
};
